// extracted by mini-css-extract-plugin
export default {"tabPanel":"DistributionLists_tabPanel__0zFgd","searchBar":"DistributionLists_searchBar__AP79C","sideBarList":"DistributionLists_sideBarList__HzlTe"};